import { render, staticRenderFns } from "./IconSvgPng.vue?vue&type=template&id=a8f5b074&scoped=true&"
import script from "./IconSvgPng.vue?vue&type=script&lang=js&"
export * from "./IconSvgPng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5b074",
  null
  
)

export default component.exports